module.exports = __webpack_public_path__ + "img/Weapon_216.c5928c75.png";